import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import {GetInterfaceLang, GetOneLearningLanguage, getStaticPageOne, EditStaticPage, getStaticPage, delPage} from '../../actions/index';
import _ from 'lodash';

class PageEdit extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.delPageOpenModal = this.delPageOpenModal.bind(this);
        this.delPageInModal = this.delPageInModal.bind(this);
        this.SubmitForm = this.SubmitForm.bind(this);
        this.renderName = this.renderName.bind(this);
        this.removeClass = this.removeClass.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        if(this.props.params.id_page){
            this.props.getStaticPageOne(token, this.props.params.id_page)
        }
        this.props.GetInterfaceLang(token);
        this.props.getStaticPage(token);
    }
    componentWillUnmount(){
        this.props.static_page.page_one = {};
    }
    edit(e){
        let block = $(e.target).data('id')
        $('#'+block+' .idetBlock').summernote({
            lang: "ru-RU",
            height: 150,
            dialogsInBody: true,
            toolbar: [
                ["font", ["bold", "underline", "clear"]],
                ['fontsize', ['fontsize']],
                ['color', ['color']],
                ["para", ["ul", "ol", "paragraph"]],
                ["table", ["table"]],
                ["insert", ["link", "picture", "video"]],
                ["view", ["fullscreen", "codeview"]]
            ]
        });
        $('#'+block+' .btn-primary').show();
    };
    save(e){
        let block = $(e.target).data('id')
        let makrup = $('#'+block+' .idetBlock').summernote('code');
        $('#'+block+' .idetBlock').summernote('destroy');
        $('#'+block+' .btn-primary').hide();
        $('#'+block+' .idetBlock').closest('.addWordBlock').removeClass('has-error');
    };
    delPageInModal(){
        let token = localStorage.getItem('id_token_admin');
        this.props.delPage(token, this.props.params.id_page).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                this.context.router.push('/static_page');
            }
        });
    }
    removeClass(e){
        $(e.target).parent().removeClass('has-error');
        if(e.target.name == 'price' || e.target.name == 'term'){
            this.props.fields[e.target.name].onChange(e.target.value)
        }
    }
    delPageOpenModal(){
        $('#delPage').modal('show');
    }
    closeModal(){
        $('#delPage').modal('hide');
    }
    SubmitForm(){
        let token = localStorage.getItem('id_token_admin');
        let block = $('.row_for_translate');
        let arr = [];
        let props = {};
        for(let i=0; i<block.length; i++){
            let oneBlock = block[i];
            if($(oneBlock).find('input.title').val() != ''){
                if($(oneBlock).find('input.slug').val() != ''){
                    if($(oneBlock).find('.idetBlock').html() != '' && $(oneBlock).find('.idetBlock').html() != '<p><br></p>'){
                        let obj={
                            content: $(oneBlock).find('.idetBlock').html(),
                            blang: parseInt($(oneBlock).attr('id')),
                            title: $(oneBlock).find('input.title').val(),
                            slug: $(oneBlock).find('input.slug').val()
                        };
                        arr.push(obj)
                    }else{
                        $(oneBlock).find('.idetBlock').closest('.addWordBlock').addClass('has-error');
                    }
                }else{
                    $(oneBlock).find('input.slug').parent().addClass('has-error');
                }
            }else{
                $(oneBlock).find('input.title').parent().addClass('has-error');
            }
        }
        if($('.formPage').find('.has-error').length > 0){return false}else {
            let obj={
                translations: arr,
                inner_name: this.props.static_page.page_one.inner_name,
                id: this.props.static_page.page_one.id
            }
            if(this.props.params.id_page){
                this.props.EditStaticPage(token, obj, this.props.params.id_page).then((response)=>{
                    if(response.payload.status == 200){
                        this.context.router.push('/static_page');
                    }
                });
            }
        }

    }
    componentWillUnmount(){
        this.props.static_page.pages = {};
        this.props.static_page.page_one = {};
    }
    editTranslation(id){
        if(this.props.params.id_page){
            let item = _.findWhere(this.props.static_page.page_one.translations, {blang: id});
            if(_.findWhere(this.props.static_page.page_one.translations, {blang: id})){
                return(
                    <div className="col-md-12 row_for_translate" id={item.blang} key={item.blang}>
                        <div className="row">
                            <div className="col-md-4" id={item.blang}>
                                <label>Title</label>
                            </div>
                            <div className="col-md-4" id={item.blang}>
                                <input type="text" className="form-control title" defaultValue={item.title} onChange={this.removeClass}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4" id={item.blang}>
                                <label>Slug</label>
                            </div>
                            <div className="col-md-4" id={item.blang}>
                                <input type="text" className="form-control slug" defaultValue={item.slug} onChange={this.removeClass}/>
                            </div>
                        </div>
                        <div className="row addWordBlock" id={'edit'+item.blang}>
                            <div className="col-md-4">
                                <label>Content</label>
                            </div>
                            <div className="col-md-4" data-name={'edit'+item.blang}>
                                <div className="idetBlock" dangerouslySetInnerHTML={{__html: item.content}}></div>
                                <div className="blockBtn">
                                    <button id="edit" data-id={'edit'+item.blang} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                                    <button id="save" data-id={'edit'+item.blang} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            else{
                return(
                    <div className="col-md-12 row_for_translate" id={id}>
                        <div className="row">
                            <div className="col-md-4" id={id}>
                                <label>Title</label>
                            </div>
                            <div className="col-md-4" id={id}>
                                <input type="text" className="form-control title" onChange={this.removeClass}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4" id={id}>
                                <label>Slug</label>
                            </div>
                            <div className="col-md-4" id={id}>
                                <input type="text" className="form-control slug" onChange={this.removeClass}/>
                            </div>
                        </div>
                        <div className="row addWordBlock" id={id}>
                            <div className="col-md-4">
                                <label>Content</label>
                            </div>
                            <div className="col-md-4" data-name={id}>
                                <div className="idetBlock"></div>
                                <div className="blockBtn">
                                    <button id="edit" data-id={id} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                                    <button id="save" data-id={id} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }else{
            return(
                <div className="col-md-12 row_for_translate" id={id}>
                    <div className="row">
                        <div className="col-md-4" id={id}>
                            <label>Title</label>
                        </div>
                        <div className="col-md-4" id={id}>
                            <input type="text" className="form-control title" onChange={this.removeClass}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4" id={id}>
                            <label>Slug</label>
                        </div>
                        <div className="col-md-4" id={id}>
                            <input type="text" className="form-control slug" onChange={this.removeClass}/>
                        </div>
                    </div>
                    <div className="row addWordBlock" id={id}>
                        <div className="col-md-4">
                            <label>Content</label>
                        </div>
                        <div className="col-md-4" data-name={item.lang.name}>
                            <div className="idetBlock"></div>
                            <div className="blockBtn">
                                <button id="edit" data-id={item.id} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                                <button id="save" data-id={item.id} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
    getTitleById(id, translations) {
        let result = '';
        translations.forEach(function(item, i){
            if(item.blang == id) {
                result = item.title;
            }
        });
        return result
    }
    renderName(id){
        return this.props.static_page.pages.results.map((item, i)=> {
            return this.getTitleById(parseInt(id), item.translations);
        })
    }
    renderTranslate(){
        let elem = this.props.lang.interface_lang.results;
        return elem.map((item)=>{
            return(
                <div className="col-md-12" key={item.lang.id}>
                    <div className='row sentences' id={item.id}>
                        <div className="col-md-12">
                            <p className="name_language">{item.lang.name}</p>
                        </div>
                        {this.editTranslation(item.id)}
                    </div>
                </div>
            )
        });
    }
    render() {
        return (
            <div className="dashboard-wrapper only_static">
                {this.props.params.id_page && this.props.static_page.page_one ? <p className="dashboard-title">{this.props.static_page.page_one.inner_name} </p> : <p className="dashboard-title">Add page</p>}
                <p className="dashboard-text">Static page</p>
                {this.props.lang.interface_lang.results && this.props.static_page.page_one != undefined ?
                    <div className="formPage white-block clearfix">
                        {this.renderTranslate()}
                    </div>
                    : ""
                }
                <div className="white-block clearfix">
                    <div className="col-md-12 text-center button-group">
                        <Link to={"static_page"} className="btn btn-default">Cancel</Link>
                        {this.props.params.id_page ? <button type="button" onClick={this.delPageOpenModal} className="btn btn-danger">Delete</button> : ""}
                        <button type="button" onClick={this.SubmitForm} className="btn btn-primary">Save</button>
                    </div>
                </div>
                <div className="modal fade" id="delPage" tabIndex="-1" role="dialog" aria-labelledby="DelPageLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#delPage"></span>
                                <p>Do you really want to delete this page?</p>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                <button onClick={this.delPageInModal} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>

        );
    }
}

function  mapStateToProps(state) {
    return{
        lang: state.lang,
        static_page: state.static_page
    }
}
export default connect(mapStateToProps, {GetInterfaceLang, GetOneLearningLanguage, getStaticPageOne, EditStaticPage, getStaticPage, delPage})(PageEdit);



// WEBPACK FOOTER //
// ./src/components/static_page/editPage.js